import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 8);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      id="nav"
      className={`fixed top-0 inset-x-0 z-50 nav-blur border-b transition-colors duration-300 ${
        scrolled ? 'border-line' : 'border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        {/* Brand */}
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 font-semibold text-[15px] tracking-tight text-ink">
            <span className="w-7 h-7 rounded-[8px] bg-blue flex items-center justify-center text-white">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </span>
            Consentry
          </Link>
          <span className="hidden sm:inline-flex items-center mono text-[11px] text-muted border border-line rounded-full px-2.5 py-1 bg-surface select-none">
            v1.4.2 · GA
          </span>
        </div>

        {/* Navigation Links */}
        <nav className="hidden md:flex items-center gap-8 text-[13.5px] text-sub font-medium">
          <a href="#features" className="hover:text-ink transition-colors">
            Features
          </a>
          <a href="#developers" className="hover:text-ink transition-colors">
            Developers
          </a>
          <a href="#security" className="hover:text-ink transition-colors">
            Security
          </a>
          <a href="#pricing" className="hover:text-ink transition-colors">
            Pricing
          </a>
          <a href="#demo" className="hover:text-ink transition-colors">
            Sandbox Demo
          </a>
        </nav>

        {/* Action Buttons */}
        <div className="flex items-center gap-3">
          <Link
            to="/login"
            className="hidden sm:inline-block text-[13.5px] font-medium text-sub hover:text-ink transition-colors px-3 py-2"
          >
            Login
          </Link>
          <a href="#pricing" className="btn-d">
            Get Access
          </a>

          {/* Mobile Menu Toggle Button */}
          <button
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-9 h-9 rounded-lg border border-line flex items-center justify-center text-sub hover:text-ink"
            aria-label="Open menu"
            aria-expanded={mobileMenuOpen}
          >
            {mobileMenuOpen ? (
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-line bg-card animate-log-slide">
          <nav className="flex flex-col px-6 py-4 gap-1 text-[14.5px] text-sub font-medium">
            <a
              href="#features"
              onClick={() => setMobileMenuOpen(false)}
              className="py-2.5 hover:text-ink"
            >
              Features
            </a>
            <a
              href="#developers"
              onClick={() => setMobileMenuOpen(false)}
              className="py-2.5 hover:text-ink"
            >
              Developers
            </a>
            <a
              href="#security"
              onClick={() => setMobileMenuOpen(false)}
              className="py-2.5 hover:text-ink"
            >
              Security
            </a>
            <a
              href="#pricing"
              onClick={() => setMobileMenuOpen(false)}
              className="py-2.5 hover:text-ink"
            >
              Pricing
            </a>
            <a
              href="#demo"
              onClick={() => setMobileMenuOpen(false)}
              className="py-2.5 hover:text-ink"
            >
              Sandbox Demo
            </a>
            <div className="pt-2 border-t border-line flex flex-col gap-2">
              <Link
                to="/login"
                className="py-2 text-center text-sm font-semibold text-sub hover:text-ink"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="btn-p justify-center text-sm py-2.5"
              >
                Get Access
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
